export const OFFICE_PRODUCT_3D_OPEN = "OFFICE_PRODUCT_3D_OPEN";
export const OFFICE_PRODUCT_3D_CLOSE = "OFFICE_PRODUCT_3D_CLOSE";

export const openOfficeProduct3D = ({
    officeId,
    productId,
    title = "",
    source = "",
    product = null,
} = {}) => ({
    type: OFFICE_PRODUCT_3D_OPEN,
    payload: {
        open: true,
        officeId: String(officeId || ""),
        productId: String(productId || ""),
        title: String(title || ""),
        source: String(source || ""),
        product: product && typeof product === "object" ? product : null,
        openedAt: Date.now(),
    },
});

export const closeOfficeProduct3D = () => ({
    type: OFFICE_PRODUCT_3D_CLOSE,
});
